"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMagnifiedImageStyle = exports.getMagnifiedImageTranslationStyle = exports.getMagnifyContainerStyle = exports.getTransitionActiveStyle = exports.getSmallImageStyle = exports.getContainerStyle = void 0;
var utils_1 = require("../utils");
function getContainerStyle(smallImage, style, lockedByHintInteraction) {
  var width = smallImage.width,
    height = smallImage.height;
  return Object.assign({
    cursor: lockedByHintInteraction ? 'default' : 'crosshair',
    position: 'relative',
    height: (0, utils_1.isFluidDimension)(height) ? height : "".concat(height, "px"),
    width: (0, utils_1.isFluidDimension)(width) ? width : "".concat(width, "px")
  }, style);
}
exports.getContainerStyle = getContainerStyle;
function getSmallImageStyle(smallImage, style) {
  var compositSmallImageStyle = Object.assign({
    pointerEvents: 'none',
    height: '100%',
    width: '100%'
  }, style);
  return compositSmallImageStyle;
}
exports.getSmallImageStyle = getSmallImageStyle;
function getTransitionActiveStyle(isTransitionActive) {
  return {
    opacity: isTransitionActive ? 1 : 0
  };
}
exports.getTransitionActiveStyle = getTransitionActiveStyle;
function getMagnifyContainerStyle(containerDimensions, style, fadeDurationInMs) {
  return Object.assign({
    width: containerDimensions.width,
    height: containerDimensions.height,
    transition: "opacity ".concat(fadeDurationInMs, "ms ease-in"),
    pointerEvents: 'none'
  }, style);
}
exports.getMagnifyContainerStyle = getMagnifyContainerStyle;
function getMagnifiedImageTranslationStyle(imageCoordinates) {
  var translate = "translate(".concat(imageCoordinates.x, "px, ").concat(imageCoordinates.y, "px)");
  return {
    transform: translate,
    WebkitTransform: translate,
    msTransform: translate
  };
}
exports.getMagnifiedImageTranslationStyle = getMagnifiedImageTranslationStyle;
function getMagnifiedImageStyle(magnifiedImage) {
  return Object.assign({
    width: magnifiedImage.width,
    height: magnifiedImage.height,
    pointerEvents: 'none'
  }, magnifiedImage.style);
}
exports.getMagnifiedImageStyle = getMagnifiedImageStyle;